import { createAction } from "@reduxjs/toolkit";
import { FetchableError, FetchableSuccess } from "../common/fetchable/helpers";
import { StakingDTO } from "./models/dto";

export namespace StakingActions {
  export enum ActionTypes {
    getStats = "Rewards: Get Stats",
    setStats = "Rewards: Set Stats",
    resetStats = "Rewards: Reset Stats",
  }

  //------------------------ Stats
  export const resetStats = createAction(ActionTypes.resetStats);

  export const getStats = createAction(ActionTypes.getStats);

  export const setStats = createAction<
    FetchableSuccess<StakingDTO.Responses.GetStats.T> | FetchableError,
    ActionTypes.setStats
  >(ActionTypes.setStats);

  export type GetStats = ReturnType<typeof getStats>;
  export type SetStats = ReturnType<typeof setStats>;
  export type ResetStats = ReturnType<typeof resetStats>;

  export type Actions =
    // ---
    GetStats | SetStats | ResetStats;
}
